import React from 'react'
import { connect } from 'react-redux'
import {  Form, Alert } from 'react-bootstrap'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { handleExpiredAuthState } from '../../redux/actions/authActions'
import EnrollmentDocumentsApi from '../../api/EnrollmentDocumentsApi'
import { ApiException, ExpiredSessionException } from '../../api/exceptions'

const api = new EnrollmentDocumentsApi();

const PendingButton = ({ auth, numeroControl, slug, documento, handleExpiredAuthState, setFile }) => {
  
  const MySwal = withReactContent(Swal)

  const handleClick = (event) => {

    if( documento.pendiente ){
      api.unmarkAsPending(numeroControl, slug)
        .then( response => {
          MySwal.fire({
            toast: true,
            icon: 'success',
            title: '¡Documento desmarcado como pendiente!',
            showConfirmButton: false,
            position: 'top-end',
            timer: 3000,
            timerProgressBar: true,
          })
          setFile({...documento, pendiente: false, razon_pendiente: '' })
        })
        .catch( error => {
          if (error instanceof ExpiredSessionException) {
            return handleExpiredAuthState();
          }
    
          MySwal.fire({
            toast: true,
            icon: 'error',
            title: (error instanceof ApiException) ? error.message : 'Hubo un error al procesar la solicitud. Intente más tarde.',
            position: 'top-end',
            timer: 3000,
            timerProgressBar: true,
          })
        })
    } else {
      MySwal.fire({ /** config */
        title: 'Pendiente',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        preConfirm: (comments) => {
          if(!comments) {
            MySwal.showValidationMessage(`Es necesario escribir el motivo`)
            return
          }
          api.markAsPending(numeroControl, slug, comments)
            .then( response => {
              MySwal.fire({
                toast: true,
                icon: 'success',
                title:'¡Documento pendiente!',
                showConfirmButton: false,
                position: 'top-end',
                timer: 3000,
                timerProgressBar: true,
              })
              setFile({ ...documento, pendiente: true, razon_pendiente: comments })
            })
            .catch( error => {
              if (error instanceof ExpiredSessionException) {
                return handleExpiredAuthState();
              }
        
              MySwal.fire({
                toast: true,
                icon: 'error',
                title: (error instanceof ApiException) ? error.message : 'Hubo un error al procesar la solicitud. Intente más tarde.',
                position: 'top-end',
                timer: 3000,
                timerProgressBar: true,
              })
            })
        },
        allowOutsideClick: () => !MySwal.isLoading()
      })
    }


  };


   return (

    <> 
      <Form>
        <div className="mb-3">
         {
           auth.user.role && documento && documento.aceptado === true && (
            <Form.Check type='checkbox'>
              <Form.Check.Input type='checkbox' checked={documento && documento.pendiente} onChange={handleClick}/>
              Marcar como pendiente
            </Form.Check>
           )
         }
          {
            documento && documento.pendiente ? (
            <Alert variant="warning">
              <h5><strong> Pendiente </strong></h5>
              <p>
                { documento.razon_pendiente }
              </p>
            </Alert>
            ) : null 
          }
        </div>
      </Form>
    </>
   )
}

const mapStateToProps = (state) => {
  return {
    auth : state.auth
  }
}

export default connect(mapStateToProps, {handleExpiredAuthState})(PendingButton)